export const STRING_REGEX = /^[a-zA-Z0-9_\s('!&@/$"`'‘’“”´)-=:]*$/
export const PNG_MIME_TYPE = 'image/png'

// Dropdown values
export const MIN_CHAR_COUNT = 2
export const SEARCH_HINT = `Type to search facilities`

// `errorMessage` is an optional localized override — callers that pass
// `isError` should supply `t('common:facility_search_error')` so the message
// is localized. Left undefined (as the ~15 pre-existing, un-localized call
// sites do — none of which ever pass `isError: true`) it falls back to the
// hardcoded English string below.
export const getFacilityNoOptionsMessage = (
  inputValue: string,
  isError = false,
  errorMessage?: string
) => {
  if (isError) {
    return (
      errorMessage ??
      'Something went wrong searching facilities. Please try again.'
    )
  }
  if (!inputValue || inputValue.length < MIN_CHAR_COUNT) {
    return SEARCH_HINT
  }
  return `No facilities found matching "${inputValue}"`
}

export const SEARCH_DEBOUNCE_TIME = 250

export const maxLength = (value: number) => ({
  value,
  message: `Must be less than ${value} characters`,
})

export const isValidFileType = (fl: FileList): boolean => {
  if (fl?.length === 0) {
    return true
  }
  return fl?.[0]?.type === PNG_MIME_TYPE
}

// AI Operator ACS resolution threshold bounds (seconds). Shared by the
// org-wide defaults in AI Operator settings and the per-device overrides in the
// device edit form so both validate against the same range.
export const MIN_THRESHOLD = 0
export const MAX_THRESHOLD = 60

export const MAX_QUICK_REPORT_NAME_CHARACTERS = 32

export const MAX_ANNOUNCEMENT_MESSAGE_LENGTH = 1000
